<template>
  <BaseContainerSpread :key="cs.id">
    <UiCsearchHeader :cs="cs" />
    <SearchBox :ss="ss" additional />
    <UiItemSearchResult :ss="ss" />
    <template v-if="showRelated && curss && csss">
      <section
        class="jps-curation-search-result"
        v-if="curss.state.result && curss.state.result.hit > 0"
      >
        <h2 class="title">
          <BaseIcon name="koicon/koicon-07" class="jps-red" />
          <span class="is-size-4-desktop is-size-5-touch">{{
            lss(
              'キーワードに関連するギャラリー',
              'Gallery related to keyword',
            )
          }}</span>
        </h2>
        <UiCarouselWithButton tag="ul" :item-width="256" :item-gap="16">
          <li v-for="cur in curss.state.result.list" :key="cur.id">
            <div class="ui-carousel-item">
              <UiDataCard type="curation" :data="cur" height="middle" />
            </div>
          </li>
        </UiCarouselWithButton>
      </section>
      <section
        class="jps-csearch-search-result"
        v-if="csss.state.result && csss.state.result.hit > 0"
      >
        <h2 class="title">
          <BaseIcon name="koicon/koicon-42" class="jps-red" />
          <span class="is-size-4-desktop is-size-5-touch">{{
            lss(
              'キーワードに関連するテーマ別検索',
              'Designed search related to keyword',
            )
          }}</span>
        </h2>
        <UiCarouselWithButton tag="ul" :item-width="256" :item-gap="16">
          <li v-for="cs in csss.state.result.list" :key="cs.id">
            <div class="ui-carousel-item">
              <UiDataCard type="csearch" :data="cs" />
            </div>
          </li>
        </UiCarouselWithButton>
      </section>
    </template>
  </BaseContainerSpread>
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
})

const { getPageAndCache, updatePageTitle } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { lss } = useI18n()
const { getTitle } = useSite()
const route = useRoute()
const dataStore = useDataStore()
const { getSearchId } = useItem()
const { searchCuration } = useCuration()
const { searchCustomSearch } = useCustomSearch()

const crossSearchId: string = systemCrossSearchCs().id

const cs = computed(() => {
  return dataStore.csearch(route.params.csId as string)
})
const ss: Ref<SearchStore<Item>> = ref()

//data
const curss: Ref<SearchStore<Curation>> = ref(null)
const csss: Ref<SearchStore<CustomSearchDefinition>> = ref(null)

const watchCS = (neu, old) => {
  if (ss.value == null || ss.value.state.searchdef.id !== neu?.id) {
    ss.value = useSearch<Item>(
      cs.value,
      getSearchId(cs.value.id),
      {
        afterRestoreQuery: (isSearch: boolean) => {
          if (import.meta.client) {
            if (isSearch) {
              const queryString = ss.value.getQueryString()
              updatePageTitle(meta, getTitle(
                {
                  ja: ss.value.state.searchdef.name.ja + queryString,
                  en: ss.value.state.searchdef.name.en + queryString
                }
              ))
              useHead(meta)
            }
          }
        }
      }
    )

    if (showRelated.value) {
      curss.value = useSearch<Curation>(
        {},
        searchCuration,
        {
          configSyncRoute: false,
          configNoLoading: true,
          configCacheSubKey: 'search_cur',
          queryRewriter: (q: SearchQuery) => {
            q.filter = { curationType: ['GALLERY'] }
            return q
          }
        }
      )

      csss.value = useSearch<CustomSearchDefinition>(
        {},
        searchCustomSearch,
        {
          configSyncRoute: false,
          configNoLoading: true,
          configCacheSubKey: 'search_cs',
          queryRewriter: (q: SearchQuery) => {
            q.filter = { type: ['NORMAL'] }
            return q
          }
        }
      )

      ss.value.addAfterSearchListener(() => {
        if (!isEmpty(ss.value.state.keyword)) {
          curss.value.state.keyword = clone(ss.value.state.keyword)
          curss.value.execute()
          csss.value.state.keyword = clone(ss.value.state.keyword)
          csss.value.execute()
        } else {
          curss.value.clear()
          csss.value.clear()
        }
      })
    }
    // let q = fromQueryString(window.location.search);
    if (checkCsId()) {
      nextTick(() => {
        ss.value.restoreQuery()
      })
    }
  }
}

watch(
  () => cs.value,
  (neu, old) => {
    watchCS(neu, old)
  },
  { deep: true }
)

const checkCsId = () => {
  let csId = route.query?.csid
  if (csId) {
    csId = Array.isArray(csId) ? csId[0] : csId
  }
  return csId == ss.value?.state?.searchdef?.id
}

const showRelated = computed(() => {
  return cs.value && cs.value.id === crossSearchId
})

;(() => {
  if (cs.value) {
    watchCS(null, null)
  }
})()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.search-page {
  padding-top: 3rem;
  @include is-mobile() {
    padding-top: 1rem;
  }
  .jps-cs-header {
    @include margin-full-width();
    margin-bottom: 1.5rem;
  }
  .jps-search-box {
    @include margin-full-width();
    margin-bottom: 1rem;
  }
  .item-search-result {
    @include margin-full-width();
  }
  > section {
    @include margin-full-width();
    margin-bottom: 3rem;
    .title {
      text-align: center;
    }
  }
  padding-bottom: 3rem;
  @include is-mobile() {
    .jps-search-box {
      padding-bottom: 1rem;
    }
    padding-bottom: 1rem;
  }
}

.jps-curation-search-result, .jps-csearch-search-result {
  .title {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      margin-top: 1rem;
    }
  }
}
</style>
